export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/projectCostPriority/index.js